/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";

import { useTranslation } from "react-i18next";
import { assetImages } from "constants";

const Header = ({ moduleName }) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t, i18n } = useTranslation(); // translation marker

  useEffect(() => {
    i18n.changeLanguage("en");
  }, []);

  return (
    <header className="header_outer">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <div className="bttm_innr d-flex align-items-center w-100">
            {/* logo */}
            <div className="home_hdrlogo">
              <Link to="/">
                <img src={assetImages.homeLogo} alt="logo" />
              </Link>
            </div>

            {/* menu */}

            <div className="header_right d-flex align-items-center justify-content-between w-100">
              <div className="menu_list">
                <Link
                  to="#"
                  onClick={() => {
                    document.body.classList.remove("add_menupnl");
                  }}
                >
                  <span className="menu_cross material-icons-outlined">
                    close
                  </span>
                </Link>

                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li
                    className={
                      moduleName == "event" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/events"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      Events
                    </Link>
                  </li>
                  <li
                    className={
                      moduleName == "agenda" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      to="/agenda"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      Agenda
                    </Link>
                  </li>
                  <li
                    className={
                      moduleName == "speakers" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      to="/speakers"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      Speakers
                    </Link>
                  </li>
                  <li
                    className={
                      moduleName == "partners" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      to="/partners"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      Partners
                    </Link>
                  </li>
                  <li
                    className={
                      moduleName == "community" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      to="/community"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      community
                    </Link>
                  </li>
                  <li
                    className={
                      moduleName == "networks" ? "nav-item active" : "nav-item"
                    }
                  >
                    <Link
                      className="nav-link"
                      to="/networks"
                      onClick={() => {
                        document.body.classList.remove("add_menupnl");
                      }}
                    >
                      Networks
                    </Link>
                  </li>
                  {token && (
                    <li
                      className={
                        moduleName == "mymeeting"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link
                        className="nav-link"
                        to="/mymeeting"
                        // data-bs-toggle="modal"
                        // data-bs-target={token ? "" : "#login_modal"}
                        onClick={() => {
                          document.body.classList.remove("add_menupnl");
                          // if (!token) {
                          //   let myModal = new bootstrap.Modal(
                          //     document.getElementById("login_modal")
                          //   );
                          //   myModal.show();
                          // }
                        }}
                      >
                        My meetings
                      </Link>
                    </li>
                  )}

                  {userInfo ? (
                    userInfo.role ? (
                      userInfo.role.name === "Admin" ? (
                        <li
                          className={
                            moduleName == "report"
                              ? "nav-item active"
                              : "nav-item"
                          }
                        >
                          <Link
                            className="nav-link"
                            to="/report"
                            onClick={() => {
                              document.body.classList.remove("add_menupnl");
                            }}
                          >
                            REPORT
                          </Link>
                        </li>
                      ) : null
                    ) : null
                  ) : null}
                </ul>
              </div>
              <div className="search_register_outer d-flex align-items-center gap-3 justify-content-end">
                {userInfo ? (
                  <div className="hdr_btn dropdown">
                    <Link
                      to="/logout"
                      className="btn primary-btn"
                      data-bs-toggle="dropdown"
                    >
                      <span> My Account</span>
                      <i className="material-icons-outlined">expand_more</i>
                    </Link>
                    <ul className="list_style_none dropdown-menu">
                      <li>
                        <Link to="/myaccount">My Profile</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/myinvites">My Invites</Link>
                      </li>
                      <li>
                        <Link to="/logout">Log out</Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div className="hdr_btn">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#login_modal"
                      className="btn primary-btn"
                    >
                      Login
                    </Link>
                  </div>
                )}
              </div>
              <div className="hamberger_menu">
                <Link
                  to="#"
                  onClick={() => {
                    document.body.classList.add("add_menupnl");
                  }}
                >
                  <span className="material-icons-outlined">menu</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div
        className="overlay"
        onClick={() => {
          document.body.classList.remove("add_menupnl");
        }}
      ></div>
    </header>
  );
};

export default Header;
